import React from "react";
import { Button } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";
import styles from "../PublishTrip.module.css";

const PublishTripActions = ({
  canPublish,
  canUseAsTemplate,
  onSave,
  onPublish,
  onUseAsTemplate,
  saveLabel,
  saveIconName = "iconPenToSquare",
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.footerActions}>
      <Button
        label={saveLabel || t("tripPublication.publishTrip.actions.saveTrip")}
        iconName={saveIconName}
        iconPosition="left"
        className="atlas-button cancel-button"
        onClick={onSave}
      />
      {canUseAsTemplate && (
        <Button
          label={t("tripPublication.publishTrip.actions.useAsTemplate")}
          iconName="iconFile"
          iconPosition="left"
          onClick={onUseAsTemplate}
        />
      )}
      {canPublish && (
        <Button
          primary={true}
          modeOfUse="edit"
          iconName="iconCheck"
          iconPosition="left"
          label={t("tripPublication.publishTrip.actions.publishTrip")}
          onClick={onPublish}
        />
      )}
    </div>
  );
};

export default PublishTripActions;
